import { render, staticRenderFns } from "./NewWebhook.vue?vue&type=template&id=011b438f&"
import script from "./NewWebhook.vue?vue&type=script&lang=js&"
export * from "./NewWebhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports